<template>
  <div class="d-flex flex-column align-items-center">
    <div class="thin text-normal-1 mb-2">There are no custom fields in your org</div>
    <div class="text-secondary text-center">
      Custom fields allow you create powerful workflows by adding columns to your initiatives.
    </div>
    <img height="200" src="@/assets/images/custom-field.png" class="mt-2 mb-4" />
    <b-button class="text-medium-1 mt-3" variant="primary" @click="$emit('new')" pill
      >New Custom Field</b-button
    >
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

/**
 * This is the empty state for Custom fields.
 * This is shown in the custom fields list when there is no item.
 */
export default {
  name: 'CustomFieldEmptyState',
  props: [],
  components: {
    BButton
  }
}
</script>

<style lang="scss" scoped></style>
